import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/biotimeDevices`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeDevices/${id}?include=employee`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function view(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeDevices/${params.id}${params.include}`, options)

        .then(response => {
            let biotimeDevice = jsona.deserialize(response.data);
            delete biotimeDevice.links;
            return biotimeDevice;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeDevices/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add(biotimeDevice) {
    const payload = jsona.serialize({
        stuff: biotimeDevice,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/biotimeDevices`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(biotimeDevice) {
    const payload = jsona.serialize({
        stuff: biotimeDevice,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/biotimeDevices/${biotimeDevice.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/biotimeDevices/${id}`, options);
}



export default {
    list,
    get,
    view,
    show,
    add,
    update,
    destroy
};

